import {  defaults } from '@/components/ui/Metabase';
import { gravComponentSchema } from '../deep-form-grav';
import {MetabaseProps} from "@/components/ui/Metabase.ts";



const { s, l, bl, c, v, src, h, toExport } = gravComponentSchema<MetabaseProps>({
  title: 'Metabase',
  link: 'https://docs.ds.mlmsoft.cloud/doc/metabase-jaCmLLsHVH',
  text: text(),
},
  defaults,
);

export default toExport;


// const paramItem = s.spawn().input('dform').data([
//   l.spawn<string>('key').asMany([l.clone('itemLeft'), bl.clone('string')])
//     .title('Param Key')
//     .props({ density: 'compact', dfTitleInside: true })
//     .col(9).item(),
//   l.spawn<string>('value').asMany([l.clone('itemRight'), bl.clone('string')])
//     .title('Param Value')
//     .props({ density: 'compact', dfTitleInside: true })
//     .col(3).item(),
// ]);

s.add('id').input('text').props({dfTitleInside: true }).title('Component ID').col(3);
s.add('resourceKey').input('text').props({dfTitleInside: true }).title('Resource Key').col(3);
s.add('resourceId').input('text').props({dfTitleInside: true }).title('Resource ID').col(3);
s.add('frameWidth').input('text').props({dfTitleInside: true }).title('Frame Width').col(3);
s.add('frameHeight').input('text').props({dfTitleInside: true }).title('Frame Height').col(3);
// s.add('chartParams').input('text').title('Chart Params').col(3);
// s.spawn<Record<string, string>>('chartParams').input('drecord').data(paramItem.item()).col(12).item()

//








function text() {
  return `
<b>UI Component: Metabase</b>
This component show data from Metabase.
  `;
}
